<template>
    <div>
        <!-- Modal Component -->
        <b-modal ref="elementModal" v-model="openModal" :title="modalTitle" size="lg" ok-title="Save Element" ok-variant="success" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" :ok-disabled="saving" :no-close-on-backdrop="true" scrollable>
            <div>
                <div class="row form-group">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Element Text: <i class="fa fa-asterisk text-danger small" v-if="!element.ElementText"></i></label>
                    <div class="col-sm-8">
                        <input type="text" v-model="element.ElementText" :class="{ 'is-invalid': errors.ElementText, 'form-control': true}" placeholder="Enter Element Name" />
                        <span v-if="errors.ElementText" class="text-danger">
                            <span v-for="error in errors.ElementText">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Display Order: <i class="fa fa-asterisk text-danger small" v-if="!element.DisplayOrder"></i></label>
                    <div class="col-sm-8">
                        <input type="number" v-model="element.DisplayOrder" :class="{ 'is-invalid': errors.DisplayOrder, 'form-control': true}" placeholder="Element Order" style="max-width: 200px;" />
                        <span v-if="errors.DisplayOrder" class="text-danger">
                            <span v-for="error in errors.DisplayOrder">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                        Score <i class="fa fa-question-circle" title="The element scores combine to the cumulative inspection score for compliant vs. non-compliant. You can set the score higher for to weight elements priority."></i>: <i class="fa fa-asterisk text-danger small" v-if="!element.element_score"></i>
                    </label>
                    <div class="col-sm-8">
                        <input type="number" v-model="element.element_score" :class="{ 'is-invalid': errors.element_score, 'form-control': true}" placeholder="Element Order" style="max-width: 200px;" />
                        <span v-if="errors.element_score" class="text-danger mt-1">
                            <span v-for="error in errors.element_score">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="row form-group" v-if="false">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Active:</label>
                    <div class="col-sm-8">
                        <b-form-checkbox v-model="element.IsActive" value="1" unchecked-value="0" plain></b-form-checkbox>
                        <span v-if="errors.IsActive" class="text-danger">
                            <span v-for="error in errors.IsActive">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">OSHA Standard URL:</label>
                    <div class="col-sm-8">
                        <input type="text" v-model="element.osha_standard_url" :class="{ 'is-invalid': errors.osha_standard_url, 'form-control': true}" placeholder="Enter URL to OSHA Standard" />
                        <span v-if="errors.osha_standard_url" class="text-danger">
                            <span v-for="error in errors.osha_standard_url">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Description:</label>
                    <div class="col-sm-8">
                        <textarea v-model="element.Description" :class="{ 'is-invalid': errors.Description, 'form-control': true}" placeholder="(optional). Element Description" style="min-height: 100px;"></textarea>
                        <span v-if="errors.Description" class="text-danger">
                            <span v-for="error in errors.Description">{{ error }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {

        data: function() {
            return {
                openModal: false,
                saving: false,
                element: {
                    element_score: 1,
                },
                errors: {},
            }
        },

        computed: {
            modalTitle(){
                if(this.element.InspectionElementId)
                {
                    return 'Edit Element';
                }

                //Default
                return 'New Element';
            }
        },

        watch: {
            element(newValue, oldValue){
                //Setter
                this.element = newValue;
            }
        },

        methods: {

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //Reset the values
                this.element = {};
                this.errors = {};
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.saveElement();
            },

            hideModal() {
                //this.$refs.correctiveActionModal.hide();
                this.openModal = false;
            },

            showModal(){
                //Show it
                this.openModal = true;
            },

            setElement(element){
                this.element = element;
                this.showModal();
            },

            saveElement: function(ajaxMode) {
                //Show loading
                this.saving = true;
                this.errors = {};

                //Send it
                this.$http
                .post('inspections/forms/element', this.element)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Form Element Saved');

                    //Emit the Data
                    this.$emit('elementSaved', response.data);

                    //Hide it
                    this.hideModal();
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    else
                    {
                        this.$toastr.error(error.response.data);
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            },

        },

        mounted() {
            //Set the height
            //this.$refs.elementModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
        }
    }
</script>